import React from 'react';
import './App.css';
import Header from "./Header";
import Sidebar from "./Sidebar";
import Feed from "./Feed";
// import { Widgets } from '@material-ui/icons';
import Widgets from "./Widgets";
import Login from "./Login";
import { useStateValue } from './StateProvider';

function App() {

  //if user set nto null, reneer login
  //if user is in, render page

  //No prop drilling , no passing it to state 
  //solution is the React Context API (a  fairly simple resemnble React Context API)
  // Data layer - wrapping - inside REDUX and React Context API - same pattern

  const [{ user }, dispatch] = useStateValue();

  return (
    <div className="app">

      {!user ? (
        <Login />
      ) : (

          <>
            {/* Header */}
            < Header />

            {/* App Body */}
            < div className="app__body">

              {/* Side Bar (Left) */}
              <Sidebar />

              {/* Feed */}
              <Feed />

              {/* Widget (Right) */}
              <Widgets />

            </div>
          </>

          // Fragemnt wrap  for siblling component

        )}



    </div >
  );
}

export default App;
